export default __webpack_public_path__ + "static/media/tracking-delivered-ico.8dea49e0.svg";